export const getEventIcon = (name: string, data?: Record<string, any>) => {
  if (name === "text" && data?.source) {
    return data.source === "speech" ? "mic" : "keyboard";
  }

  switch (name) {
    case "start":
      return "play";
    case "stop":
      return "stop";
    case "interrupt":
      return "pause";
    case "end":
      return "check";
    case "timeout":
      return "clock";
    case "text":
      return "keyboard";
    case "text_to_speech":
      return "volume-up";
    case "audio":
      return "music";
    case "silence":
      return "mute";
    case "transfer_call":
      return "phone-forward";
    case "merge_call":
      return "phone-merge";
    case "context":
      return "database";
    case "error":
      return "error";
    case "log":
      return "info";
    default:
      return "info";
  }
};

export const getEventColor = (name: string, type: string) => {
  const baseColor = (() => {
    switch (name) {
      case "start":
        return "text-green-500";
      case "stop":
        return "text-red-500";
      case "interrupt":
        return "text-yellow-500";
      case "end":
        return "text-blue-500";
      case "timeout":
        return "text-orange-500";
      case "text":
        return "text-purple-500";
      case "text_to_speech":
        return "text-indigo-500";
      case "audio":
        return "text-pink-500";
      case "silence":
        return "text-gray-500";
      case "transfer_call":
        return "text-teal-500";
      case "merge_call":
        return "text-cyan-500";
      case "context":
        return "text-emerald-500";
      case "error":
        return "text-red-600";
      case "log":
        return "text-blue-400";
      default:
        return "text-gray-500";
    }
  })();

  return type === "input" ? baseColor : "text-gray-500";
};
